import { render, staticRenderFns } from "./SilverPriceWidget.vue?vue&type=template&id=5438a910&scoped=true"
import script from "./SilverPriceWidget.vue?vue&type=script&lang=js"
export * from "./SilverPriceWidget.vue?vue&type=script&lang=js"
import style0 from "./SilverPriceWidget.vue?vue&type=style&index=0&id=5438a910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5438a910",
  null
  
)

export default component.exports